import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { CardArtifactMaxWidth, CardArtifactMinWidth, CardHeaderTitleWidth, CardHeight, CardMaxWidth, CardMinWidth, CardPreviewHeight, } from './StyleConstants';
export var useCardStyles = makeStyles({
    root: __assign(__assign({}, shorthands.overflow('visible')), { height: "".concat(CardHeight), cursor: 'pointer', minWidth: "".concat(CardMinWidth), maxWidth: "".concat(CardMaxWidth), boxSizing: 'border-box', ':hover': {
            boxShadow: tokens.shadow8,
            backgroundColor: tokens.colorNeutralBackground1Hover,
        }, ':hover .show': {
            visibility: 'visible',
        }, ':focus .show': {
            visibility: 'visible',
        }, ':focus-within .show': {
            visibility: 'visible',
        }, ':focus-visible': {
            outlineStyle: 'auto',
        }, '&:active': {
            boxShadow: tokens.shadow8,
            backgroundColor: tokens.colorNeutralBackground1Pressed,
        } }),
    // ODSP Share is positioned absolutely
    calloutContainer: {
        position: 'relative',
    },
    preview: {
        height: CardPreviewHeight,
    },
    headerRoot: {
        boxSizing: 'border-box',
        zIndex: 1,
    },
    previewThumbnail: {
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center top',
    },
    previewErrorThumbnail: {
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: tokens.colorNeutralBackground4,
    },
    headerTitle: {
        width: "".concat(CardHeaderTitleWidth),
        color: tokens.colorNeutralForeground1,
    },
    headerTitleBody: {
        width: '100%',
        display: 'flex',
    },
    headerTitleText: __assign(__assign({}, shorthands.overflow('hidden')), { color: tokens.colorNeutralForeground1, fontSize: tokens.fontSizeBase300, fontWeight: tokens.fontWeightSemibold, textOverflow: 'ellipsis' }),
    tagGroup: {
        marginLeft: '4px',
        maxWidth: '60px', // max 3 * 16px-icons + 2 * 6px-margins
    },
    headerSubTitle: {
        width: "".concat(CardHeaderTitleWidth),
        color: tokens.colorNeutralForeground3,
    },
    artifactButton: __assign(__assign({ maxWidth: '100%', width: CardMaxWidth }, shorthands.borderRadius('0px', '0px', '4px', '4px')), { zIndex: 1 }),
    artifactMenuPopOver: {
        minWidth: CardArtifactMinWidth,
        maxWidth: CardArtifactMaxWidth,
        zIndex: 101,
    },
    actionsMenuLink: {
        display: 'inline-block',
    },
    documentListItemIconMenu: __assign(__assign(__assign({ visibility: 'hidden', alignItems: 'center', justifyContent: 'center' }, shorthands.padding(0)), shorthands.overflow('hidden')), { whiteSpace: 'nowrap' }),
    meetingObjectPreviewThumbnail: {
        backgroundColor: '#E2E2F6', //Teams Tint 40
    },
    meetingObjectPreviewThumbnailIcon: {
        color: ' #6264A7', //Teams Primary
    },
});
//# sourceMappingURL=EdgeworthItemCardControl.styles.js.map